import _map from 'lodash/map';
import Stack from '../../../_components/Stack';
import { Button } from '../../Button';
import { FeaturedIcon } from '../../FeaturedIcon';
import { Pill } from '../../Pill';
import EmptyStateDescription from '../components/EmptyStateDescription';
import EmptyStateTitle from '../components/EmptyStateTitle';
import { containerVariants, titleVariants } from '../styles';
import type { EmptyStateWithListProps } from '../types';

function EmptyStateWithList(props: EmptyStateWithListProps) {
  const { title, description, Icon, list, buttons, variant, learnMore } = props;
  const containerClassName = containerVariants({ variant });
  const titleClassName = titleVariants({ variant });

  return (
    <Stack
      alignItems="start"
      className={containerClassName}
      direction="column"
      justifyContent="end"
    >
      <Stack className="border-tertiary gap-y-2xl pb-xl w-full border-b">
        {Icon ? <FeaturedIcon color="gray" Icon={Icon} size="md" /> : null}
        <Stack>
          <EmptyStateTitle className={titleClassName} title={title} />
          {description ? (
            <EmptyStateDescription description={description} learnMore={learnMore} />
          ) : null}
        </Stack>
      </Stack>
      <Stack className="py-xl gap-y-lg border-tertiary border-b">
        {_map(list, (item, index) => {
          return (
            <Stack className="gap-x-md" direction="row" key={`${item.title} ${index}`}>
              {item.Icon ? (
                <Stack className="pt-lg">
                  <FeaturedIcon color="brand" Icon={item.Icon} size="xs" />
                </Stack>
              ) : null}
              <Stack className="pt-sm px-md pb-md flex-1">
                <Stack className="gap-x-md" direction="row">
                  <EmptyStateTitle title={item.title} variant="text-sm" />
                  {item.isOptional ? <Pill label="Optional" size="xs" variant="soft" /> : null}
                </Stack>
                <EmptyStateDescription color="text-tertiary" description={item.description} />
              </Stack>
            </Stack>
          );
        })}
      </Stack>
      {buttons.length ? (
        <Stack className="gap-x-lg pt-2xl" direction="row">
          {_map(buttons, (button, index) => {
            return (
              <Button
                color="brand"
                key={`${button.label} ${index}`}
                size="md"
                variant="solid"
                {...button}
              >
                {button.label}
              </Button>
            );
          })}
        </Stack>
      ) : null}
    </Stack>
  );
}

export default EmptyStateWithList;
